import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	NotificationEmpty: {
		k: "message.notificationEmpty",
		v: "No Message"
	},
	NotificationNotfoundDescription: {
		k: "message.notificationNotfoundDescription",
		v: "Not Notification Found"
	}
	
});



// WEBPACK FOOTER //
// ./src/panels/message/MessageNotification.label.tsx